import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// Component for Vehicle Bill Form
const VehicleBillForm = () => {
useAuthRedirect();
const {vcode, id} = useParams();
const navigate = useNavigate(); 
  const [vehicle, setVehicle] = useState('');
  const [details, setVehicleDetails] = useState('');
  const [fetchPrice, setFetchPrice] = useState(null);
  const [hoursAmount, setHoursAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const branch = localStorage.getItem("branch");


  useEffect(() => {
    const fetchVehicleDetails = async () => {
        try {
            const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/bill_view_details?branch=${branch}&id=${id}`);
            // console.log("API Response:", response.data.billDetails);

            if (response.data.billDetails && response.data.billDetails.length > 0) {
                setVehicleDetails({
                    billNo: response.data.billDetails[0].fld_billno || "",
                    billDate: response.data.billDetails[0].fld_billdate || "",
                    party: response.data.billDetails[0].fld_partyname || "",
                    vehicleName: response.data.billDetails[0].fld_vehiname || "",
                    vcode: response.data.billDetails[0].fld_equip || "",
                    vehicleType: response.data.billDetails[0].fld_vehitype || "",
                    preparedBy: response.data.billDetails[0].fld_billprepared || "",
                    particular: response.data.billDetails[0].fld_particular || "",
                    hours: response.data.billDetails[0].fld_hours || "",
                    tot: response.data.billDetails[0].fld_gamt || "",
                    bata: response.data.billDetails[0].fld_bata || "",
                    bataTot: response.data.billDetails[0].fld_batatot || "",
                    bataTot: response.data.billDetails[0].fld_batatot || "",
                    totKm: response.data.billDetails[0].fld_monthkm || "",
                    breakAmt: response.data.billDetails[0].fld_breakamt || "",
                    breakTot: response.data.billDetails[0].fld_batatot || "",
                    matReason: response.data.billDetails[0].fld_metdetection || "",
                    tdsPer: response.data.billDetails[0].fld_percent || "",
                    tdsTot: response.data.billDetails[0].fld_namt || "",
                    breakHr: response.data.billDetails[0].fld_breakhour || "",
                    tdsAmt: response.data.billDetails[0].fld_taxparti || "",
                    mainReason: response.data.billDetails[0].fld_metdetection || "",
                    decReason: response.data.billDetails[0].fld_decReason || "",
                    mainAmt: response.data.billDetails[0].fld_maintamt || "",
                    otherAmt: response.data.billDetails[0].fld_otheramt || "",
                    balancePay: response.data.billDetails[0].fld_balancepay || "",
                });
            }
        } catch (error) {
            console.error("Error fetching vehicle details:", error);
        }
    };

    fetchVehicleDetails();
}, [branch, id]);  

useEffect(() => {
    const fetchVehicle = async () => {
        try {
            const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/vehicleBasis?vcode=${details.vcode}`);
            console.log(response);
            
            console.log("vdetails:", response.data.vBasis);

            if (response.data.vBasis && response.data.vBasis.length > 0) {
                setVehicle({
                    basis: response.data.vBasis[0].fld_vbasis || "",
                });
            }
        } catch (error) {
            console.error("Error fetching vehicle details:", error);
        }
    };

    fetchVehicle();
}, [details.vcode]);  



const exportToExcel = () => {
  const exportRows = [];

  // Header info as key-value rows
  exportRows.push(
    { Label: "Bill Number", Value: details.billNo },
    { Label: "Date", Value: new Date().toISOString().split("T")[0] },
    { Label: "Name of the party", Value: details.party },
    { Label: "Branch", Value: branch },
    { Label: "Vehicle name", Value: details.vehicleName },
    { Label: "Vehicle Type", Value: details.vehicleType },
    { Label: "Equipment", Value: details.vcode },
    { Label: "Prepared By", Value: details.preparedBy }
  );

  exportRows.push({ Label: "", Value: "" }); // spacer row

  // Bill table data
  exportRows.push({
    Label: "Bill Date",
    Value: details.billDate || new Date().toISOString().split("T")[0],
    Particular: details.particular,
    "Worked Hr / Km": details.hours,
    "Rate/Hr": Number(details.tot || 0).toFixed(2),
    "Total Amount": Number(details.tot || 0).toFixed(2)
  });

  exportRows.push({ Label: "", Value: "" }); // spacer

  // Others / Bata
  exportRows.push(
    { Label: "Total Amount", Value: Number(details.tot || 0).toFixed(2) },
    { Label: "Bata (Other Charges)", Value: Number(details.bata || 0).toFixed(2) },
    { Label: "Grand Total", Value: Number(details.bataTot || 0).toFixed(2) }
  );

  exportRows.push({ Label: "", Value: "" });

  // If vehicle.basis is Month, add monthly block
  if (vehicle.basis === "Month") {
    exportRows.push({
      Label: "Total Km",
      "Breaking Hours": details.breakHr,
      "Breaking Hours Amount": Number(details.breakAmt || 0).toFixed(2),
      "Total Amount": Number(details.breakTot || 0).toFixed(2)
    });

    exportRows.push({ Label: "", Value: "" });
  }

  // Material Deduction block
  exportRows.push({
    Label: "Material Deductions",
    "TDS Deductions %": details.tdsPer || "N/A",
    "TDS Amount": details.tdsAmt,
    "Grand Total (After TDS adding)": details.tdsTot
  });

  exportRows.push({ Label: "", Value: "" });

  // Final Deductions
  exportRows.push(
    { Label: "Maintenance Reason", Value: details.mainReason },
    { Label: "Reason for Deduction", Value: details.decReason },
    { Label: "Maintenance Charges", Value: details.mainAmt },
    { Label: "Other Deduction", Value: details.otherAmt },
    { Label: "Balance Payable", Value: details.balancePay }
  );

  // Convert to worksheet and export
  const worksheet = XLSX.utils.json_to_sheet(exportRows, { skipHeader: false });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Bill Details");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(blob, "bill_disapproval.xlsx");
};
    

 


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
           <div className="back-div">
  <h2 className="add-txt">Hire Bills View</h2>
  <p className="back-button" onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
    <i className="fa-solid fa-backward"></i> Back
  </p>
</div>
          
          <Time />
        </section>

        <div className="add-new-container">
  <button className="add-new-btn" onClick={exportToExcel}>
    <i className="fa-solid fa-file-excel"></i> Export to Excel
  </button>
</div><br></br>

      

        <div className="bill-container">
          <form  className="bill-form">
            <table className="bill-table">
              <tbody>
                <tr>
                  <td>Bill Number:</td>
                  <td><input type="text" name="billNo"  value={details.billNo}  readOnly/></td>
                  <td>Date:</td>
                  <td><input type="date" name="dateIssued" value={new Date().toISOString().split("T")[0]} readOnly /></td>
                </tr>

                <tr>
                  <td>Name of the party:</td>
                  <td>
                  <input type="text" name="owner" value={details.party}    readOnly/>
                  </td>
                  <td>Branch:</td>
                  <td><input type="text" name="panCard" value={branch}  readOnly/></td>
                </tr>

                <tr>
                  <td>Vehicle name:</td>
                  <td><input type="text" name="vehicleName" value={details.vehicleName}  readOnly/> </td>
                  <td>Vehicle Type:</td>
                  <td><input type="text" name="mailingAddress" value={details.vehicleType}  readOnly/></td>
                </tr>

                <tr>
                  <td>Equipment:</td>
                  <td><input type="text"  name="vehicleType" value={details.vcode}  readOnly/></td>
                  <td>Prepared By:</td>
                  <td> <input type="text" name="vehicleBasis" value={details.preparedBy} readOnly/></td>
                </tr>
              </tbody>
            </table>

            <table className="bill-table">
              <thead>
                <tr>
                  <th>Bill Date</th>
                  <th>Particular</th>
                  <th>Worked Hr / Km</th>
                  <th>Rate/Hr</th>
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>


                <td>{
      new Date(details.billDate).toLocaleDateString("en-GB") // d/m/Y format
    }</td>
                  <td>{details.particular}</td>
                  {/* <td >{fetchPrice !== null ? (basis === "Month" ? `${fetchPrice <= 1 ? fetchPrice + " Day" : fetchPrice + " Days"}` : parseFloat(fetchPrice).toFixed(2)) : ("N/A")}<input type="hidden" name="hours" value={fetchPrice || ""} /></td> */}
                  <td><div align="center">{details.hours}</div></td>
                <td ><div align="center" id="amount">{(details.tot || 0).toFixed(2)}</div></td>
                <td ><div align="center" id="amount">{(details.tot || 0).toFixed(2)}</div></td>
               </tr>
              </tbody>
            </table>

             <h3>Others (Bata)</h3>
            <table className="bill-table">
              <tbody>
                <tr><td>Total Amount:</td><td>{Number(details.tot || 0).toFixed(2)}</td></tr>
                <tr><td>Bata (Other Charges):</td><td>{Number(details.bata || 0).toFixed(2)}</td></tr>
                <tr><td><strong>Grand Total:</strong></td><td><strong>{Number(details.bataTot || 0).toFixed(2)}</strong></td></tr>
              </tbody>
            </table>

            {vehicle.basis === "Month" && (
        <table border="1">
          <thead>
            <tr>
              <th>Total km</th>
              <th>Breaking Hours</th>
              <th>Breaking Hours Amount</th>
              <th>Total Amount</th>
            </tr>
          </thead>
          <tbody>
          <tr>
  <td>{details.totKm}</td>
  <td>{details.breakHr}</td>
  <td>{details.breakAmt ? Number(details.breakAmt).toFixed(2) : "0.00"}</td>
  <td>{details?.breakTot ? Number(details.breakTot).toFixed(2) : "0.00"}</td>
</tr>

          </tbody>
        </table>
      )}

           
            <table border="1">
          <thead>
            <tr>
              <th>Material Deductions</th>
              <th>TDS Deductions %</th>
              <th>TDS Amount</th>
              <th>Grand Total (After TDS adding)</th>
            </tr>
          </thead>
          <tbody>
          <tr> 
            
          
   <td>{details.matReason}</td>
  <td>{details.tdsPer ?? "N/A"}</td>
  <td><strong>{details.tdsAmt}</strong></td>
  <td>{details.tdsTot}</td>
  </tr>

          </tbody>
        </table>

         <h3>TDS </h3>
        <table className="bill-table">
              <tbody>
                <tr><td><strong>Maintenance Reason:</strong></td><td>{details.mainReason}</td></tr>
                <tr><td><strong>Reason for Deduction:</strong></td><td>{details.decReason}</td></tr>
                <tr>
        <td><strong>Maintenance Charges :</strong></td>
        <td>{details.mainAmt}</td>
      </tr>
      <tr>
        <td><strong>Other Deduction :</strong></td>
        <td>{details.otherAmt}</td>
      </tr>
      <tr>
        <td><strong>Balance Payable :</strong></td>
        <td><strong>{details.balancePay}</strong></td>
        
      </tr>

              </tbody>
            </table>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VehicleBillForm;
